<template>
    <div id="invoice-ticket-component">
        <div class="row">
            <form id="ticket_form" class="ticket_form">

                <div  v-for="(row, index) in invoice_array" :key="index">
                    <input type="hidden" name="invoice_array[]" :value="row">
                </div>

                <input type="hidden" name="type_model" id="" :value="type_model">
                <input type="hidden" name="supplier_id" id="" :value="supplier_id_row">
                <div class="col-12 col-sm-12">
                    <input type="text" name="monto" class="al-inputs required scr-input" placeholder="Monto" id="monto"
                           :value="formatCurrency(total_invoice_row)">
                </div>
                <div class="col-12 col-sm-12">
                    <div class="fotoUploader">
                    <span class="btn btn-file">
                        Documento <br> <i class="fas fa-upload"></i>
                        <input type="file" class="required"
                               accept="image/*,.pdf"
                               data-name-input="ticketImg" name="ticketImg"
                               v-on:change="getLogo"
                               placeholder="ticketImg">
                    </span>
                        <span class="label-file-papeleria alert alert-info ticket"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .jpeg, .png, .jpg, .gif, .pdf, con un peso máximo de 500kb</strong>
                    </p>
                </div>
            </form>
            <div class="col-12 col-sm-12">
                <button id="dyn-button" class="btn btn-primary addNote" v-on:click="guardarTicket()">
                    Subir Ticket
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";

import {ticketInvoiceService} from "../../Services/TicketInvoice.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: 'invoice-ticket',
    mixins: [myMixins],
    props: {
        invoice_array: {
            type: Array,
            required: true
        },
        total_invoice_row: {
            type: String|Number,
            required: true
        },
        supplier_id_row: {
            type: Number,
            required: true,
            comments: 'Es el id del proveedor al que se le cargaran las facturas',
        },
        type_model: {
            type: String,
            required: true,
            comments: 'Este me va a servir para saber a que carpeta va a subir el archivo',
        },
    },
    data() {
        return {
            modificar: false,
            tituloBtn: 'Agregar Documento',
        }
    },
    methods: {
        async guardarTicket() {
            //console.log('guardarTicket');
            let resp = '';
            let respVal = this.valFormulariosV3('ticket_form');
            if (respVal) {
                this.disableSubmitBtn(true);
                //DINAMICAMENTE ASIGNAMOS EL VALOR DEL CAMPO A GUARDAR
                //this.ticket[myField] = this.item;
                const formData = getFormData('ticket_form');
                resp = await ticketInvoiceService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });

                this.getAlert(resp.process,true);
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },

        getLogo(event) {
            this.getNameFile(event, 'ticket');
        },
    },
    watch: {
        type_model(newVal) {
            // Realiza las acciones necesarias cuando type_model cambie
            console.log('type_model ha cambiado:', newVal);
            // Aquí puedes actualizar cualquier lógica interna o estado
        }
    },
    mounted() {
    }
}
</script>
